import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Modal } from 'antd-mobile';
import { createCookie, readCookie } from '../../../utils/common';
import { _track } from '../../../utils/track';
import { getUploadToken } from '../../../pages/copyright/upload/action';
import './index.scss';
export const VBottomNav = props => {
	let history = useHistory();
	let dispatch = useDispatch();
	let alert = Modal.alert;
	let [isBottomPop, setIsBottomPop] = useState(false);
	let { activeName = 'home' } = props;
	const trackValues = {
		home: '首页',
		events: '活动',
		release: '发布',
		activitylist: '图库',
		ucenter: '个人中心'
	};
	function linkToPage(name) {
		let search = window.location.search;
		_track({
			trackName: activeName + '_action',
			payload: {
				activeName,
				page_action_name: activeName + '-bottomnav-' + name,
				tab_name: trackValues[name]
			}
		});
		setTimeout(() => {
			if (name === 'home' && activeName !== name) {
				window.location.href = '/vpmobile/copyright/home/' + search;
			} else if (name === 'events' && activeName !== name) {
				window.location.href = '/vpmobile/copyright/events/' + search;
			} else if (name === 'release' && activeName !== name) {
				//TODO 调getUploadAccessToken接口，失败提示错误信息'请重新登录'，成功执行回调
				if (!readCookie('copyrightphone')) {
					window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent('/vpmobile/copyright/' + activeName);
					return;
				}
				dispatch(
					getUploadToken(null, data => {
						if (data.code !== 0) {
							createCookie('userToken', '', 180);
							alert('提示', '登录过期，是否去登录？', [
								{ text: '再看看', onPress: () => {} },
								{
									text: '去登录',
									onPress: () => {
										window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent('/vpmobile/copyright/' + activeName);
									}
								}
							]);
							return;
						}
						setIsBottomPop(true);
					})
				);
				//				setIsBottomPop(true);
				//				window.location.href = '/vpmobile/copyright/events/' + search;
			} else if (name === 'activitylist' && activeName !== name) {
				// history.push({
				// 	pathname: '/vpmobile/copyright/gallery'
				// });
				// iOS 中，location.href 跳到图库，图库 history.push 到大图页，这时在大图页分享并自定义链接
				// 到首页，签名不会报错。如果 push 到图库再 push 到大图页，签名就会报错。
				// 可能的原因 https://www.cnblogs.com/dengxiaolei/p/8143838.html
				window.location.href = '/vpmobile/copyright/activitylist/' + search;
			} else if (name === 'ucenter' && activeName !== name) {
				if (readCookie('copyrightphone')) {
					window.location.href = '/vpmobile/copyright/ucenter/' + search;
				} else {
					window.location.href = '/vpmobile/copyright/login/' + search;
				}
			} else if (name === 'search' && activeName !== name) {
				window.location.href = '/vpmobile/copyright/search/' + search;
			}
		});
	}
	return (
		<div className="copyright-bottom-nav">
			<ul>
				<li
					className={activeName === 'home' ? 'active' : ''}
					onClick={() => {
						linkToPage('home');
					}}>
					<i>&#xe64e;</i>
					<br />
					首页
				</li>
				<li
					className={activeName === 'events' ? 'active' : ''}
					onClick={() => {
						linkToPage('events');
					}}>
					<i>&#xe671;</i>
					<br />
					活动
				</li>
				<li
					style={{ position: 'relative' }}
					className={activeName === 'release' ? 'active' : ''}
					onClick={() => {
						linkToPage('release');
					}}>
					<div style={{ margin: '-16px 0 5px', padding: '6px 9px 8px 7px', borderRadius: '40px', background: '#3C3C3C', color: '#fff', boxShadow: '0 2px 5px 0 rgba(0,0,0,0.2)' }}>
						<i style={{ transform: 'rotate(45deg)', marginLeft: '3px', paddingTop: '3px' }}>&#xe652;</i>
					</div>
					发布
				</li>
				<li
					className={activeName === 'activitylist' ? 'active' : ''}
					onClick={() => {
						linkToPage('activitylist');
					}}>
					<i>&#xe650;</i>
					<br />
					图库
				</li>
				<li
					className={activeName === 'ucenter' ? 'active' : ''}
					onClick={() => {
						linkToPage('ucenter');
					}}>
					<i>&#xe64d;</i>
					<br />
					个人中心
				</li>
			</ul>
			<div className={'bottom-pop-mask ' + (isBottomPop ? 'active' : '')}></div>
			<div className={'botoom-pop ' + (isBottomPop ? 'active' : '')}>
				<div className="title">发布作品</div>
				<ul>
					<li
						onClick={() => {
							history.push({
								pathname: '/vpmobile/copyright/upload/0/0'
							});
						}}>
						<img alt="" src={require('./i/image.svg')} width={31} height={36} />
						<br />
						上传照片
					</li>
					<li
						onClick={() => {
							history.push({
								pathname: '/vpmobile/copyright/upload/0/1'
							});
						}}>
						<img alt="" src={require('./i/video.svg')} width={31} height={36} />
						<br />
						上传视频
					</li>
				</ul>
				<div className="close-wrap">
					<div
						onClick={() => {
							setIsBottomPop(false);
						}}>
						<i className="iconfont">&#xe652;</i>
						<br />
						关闭
					</div>
				</div>
			</div>
		</div>
	);
};
